// "הגדל" ליצירה שלמה (web-ai-stage-layout): כל ה-Screen של הריצה על כל שטח האפליקציה — אותו רכיב Expand של הבלוקים,
// אותה מחווה (Esc / "חזור" / לחיצה מחוץ). בלוק בתוך יצירה מוגדלת נפתח גם הוא בהגדלה משלו (fixed בתוך fixed).
import type { ReactNode } from 'react';
import { Expand, ExpandButton } from '@aibify/display/client';

export function ScreenExpand({ labelHe, children }: { labelHe?: string; children: ReactNode }) {
  return (
    <Expand labelHe={labelHe} testId="screen-expand">
      <div className="flex min-w-0 flex-col gap-2">
        <div className="flex justify-end empty:hidden">
          <ExpandButton labelHe={labelHe} testId="screen-expand-btn" />
        </div>
        {children}
      </div>
    </Expand>
  );
}
